<template>
<div class="chapter">
<div class="inner_page">
<div class="Dedication">
<p>To my colleagues and students at Wycliffe Hall<br/>
    who give me much hope for the future of preaching</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?7ea13c93